import { observer } from "mobx-react-lite";
import { Mail, Users } from "lucide-react";
import { useTran } from "@/hooks";
import AppDialog from "@/components/common/AppDialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SurveyShareGuestTab from "./SurveyShareGuestTab";
import SurveyShareInternalTab from "./SurveyShareInternalTab";
import { useSurveyShareStore } from "../hooks";

const SurveyShareDialog = () => {
  const { t } = useTran();
  const shareStore = useSurveyShareStore();
  const { open, survey } = shareStore;

  const handleSendInternal = async () => {
    const success = await shareStore.sendInternalInvites();
    if (success) {
      shareStore.closeDialog();
    }
  };

  const handleSendGuest = async () => {
    const success = await shareStore.sendGuestInvite();
    if (success) {
      shareStore.closeDialog();
    }
  };

  return (
    <AppDialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) shareStore.closeDialog();
      }}
      title={survey?.title || t("Share survey")}
      description={t(
        "Invite internal users or a guest email. Only invited recipients can respond.",
      )}
      size="lg"
      bodyClassName="space-y-4"
    >
      <Tabs
        value={shareStore.mode}
        onValueChange={shareStore.setMode}
        className="flex flex-col h-[380px]"
      >
        <TabsList>
          <TabsTrigger value="internal" className="flex items-center gap-2">
            <Users className="h-4 w-4" /> {t("Internal users")}
          </TabsTrigger>
          <TabsTrigger value="guest" className="flex items-center gap-2">
            <Mail className="h-4 w-4" /> {t("Guest email")}
          </TabsTrigger>
        </TabsList>

        <TabsContent
          value="internal"
          className="flex flex-1 flex-col  overflow-hidden"
        >
          <SurveyShareInternalTab onSendInvites={handleSendInternal} />
        </TabsContent>

        <TabsContent
          value="guest"
          className="flex flex-1 flex-col overflow-hidden"
        >
          <SurveyShareGuestTab onSendInvite={handleSendGuest} />
        </TabsContent>
      </Tabs>
    </AppDialog>
  );
};

export default observer(SurveyShareDialog);
